import React from 'react';

export function PeopleIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 48 48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13 27.5c1.375 0 2.5 1.125 2.5 2.5s-1.125 2.5-2.5 2.5a2.507 2.507 0 01-2.5-2.5c0-1.375 1.125-2.5 2.5-2.5zM13 40c3.375 0 7.25 1.612 7.5 2.5h-15c.287-.9 4.137-2.5 7.5-2.5zm0-15c-2.762 0-5 2.238-5 5 0 2.763 2.238 5 5 5s5-2.237 5-5c0-2.762-2.238-5-5-5zm0 12.5c-3.338 0-10 1.675-10 5V45h20v-2.5c0-3.325-6.663-5-10-5zM35 27.5c1.375 0 2.5 1.125 2.5 2.5s-1.125 2.5-2.5 2.5a2.507 2.507 0 01-2.5-2.5c0-1.375 1.125-2.5 2.5-2.5zM35 40c3.375 0 7.25 1.612 7.5 2.5h-15c.288-.9 4.137-2.5 7.5-2.5zm0-15c-2.763 0-5 2.238-5 5 0 2.763 2.237 5 5 5s5-2.237 5-5c0-2.762-2.237-5-5-5zm0 12.5c-3.337 0-10 1.675-10 5V45h20v-2.5c0-3.325-6.663-5-10-5zM24 5.5c1.375 0 2.5 1.125 2.5 2.5s-1.125 2.5-2.5 2.5A2.507 2.507 0 0121.5 8c0-1.375 1.125-2.5 2.5-2.5zM24 18c3.375 0 7.25 1.613 7.5 2.5h-15c.288-.9 4.137-2.5 7.5-2.5zm0-15c-2.762 0-5 2.237-5 5 0 2.762 2.238 5 5 5s5-2.238 5-5c0-2.763-2.238-5-5-5zm0 12.5c-3.337 0-10 1.675-10 5V23h20v-2.5c0-3.325-6.663-5-10-5z"
      />
    </svg>
  );
}
